<!-- ReqAgentCertENIncome2YearsView -->
<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link" to="/AgenteService">ขอหนังสือรับรองการทำงาน</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ส่งเอกสารเพิ่มเติม ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้ของปีนี้ และปีที่แล้ว)
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          ps-3
          pe-3
        " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                   ส่งเอกสารเพิ่มเติม ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้ของปีนี้ และปีที่แล้ว)
                </div>
            </div>

            <div class="col">
                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ส่งเอกสารเพิ่มเติม ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้ของปีนี้ และปีที่แล้ว)
                </div>

                <!--  -->
                <div class="font-family-bla my-3">

                    <div class="pb-2 pb-lg-2">
                        <div class="mt-2 mt-lg-2">
                            <div class="blue-1 fs-5 d-lg-inline-block mt-lg-2 font-family">
                                ตัวแทน : {{ this.$store.state.UserName }}
                            </div>
                        </div>
                    </div>

                    <div class="row mb-3 mt-2">
                        <div class="col-6 col-lg-6">
                            <button type="button" class="btn btn-light btn-cancel font-family d-inline-block"
                                data-bs-toggle="modal" data-bs-target="#exampleModal">
                                ยกเลิก
                            </button>
                        </div>
                        <div class="col-6 col-lg-6 text-right">
                            <button type="button" class="btn btn-continue font-family d-inline-block"
                                data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                แนบเอกสาร
                            </button>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade font-family" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="icon-model">
                        <img src="@/assets/images/icon-warning.svg" class="w-100" />
                    </div>
                    <div class="massege fw-normal text-center">
                        <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
                        <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
                        <p class="mb-0 pt-lg-4">
                            ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
                        </p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light fw-normal popup_cancel " data-bs-dismiss="modal">
                        ไม่ต้องการ
                    </button>
                    <router-link to="/SendAdditionalDoc">
                        <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal"
                            @click="ClearData()">ต้องการ</button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal แนบหลักฐาน -->
    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content font-family">
                <div class="modal-header">
                    <h1 class="modal-title fs-4 blue-1" id="staticBackdropLabel">
                        กรุณาแนบหลักฐาน
                    </h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body fw-normal fs-5">
                    <div class="gray-3">ท่านได้ทำการขอเปลี่ยนแปลงข้อมูล ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้ของปีนี้ และปีที่แล้ว)</div>
                    <div>
                        <label>กรุณา</label><label class="blue-1 ps-1 pe-1">"แนบไฟล์"</label>
                    </div>
                    <div class="ps-2 upload-container">
                        <ol class="file-upload-list">
                            <!-- เอกสารเพิ่มเติม -->
                            <li class="ps-2 blue-1 upload-item">
                                รายละเอียดเอกสารประเภทงานบริการ ขอเปลี่ยนแปลงข้อมูล
                                ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้ของปีนี้ และปีที่แล้ว)

                                <!-- เอกสารเพิ่มเติม -->
                                <div class="alert">
                                    <!-- Drag and Drop area -->
                                    <div class=" row shadow-sm" @click="triggerFileInput('additionalFiles')">
                                        <button type="button" class="border btn btn-light w-100">
                                            <a class="fs-4 blue-1">แนบไฟล์</a>
                                        </button>
                                    </div>

                                    <div v-for="(file, index) in additionalFiles" :key="index" class="file-preview">

                                        <div class="row alert text-bg-success" role="alert">
                                            <div class="col-6 text-truncate">
                                                {{ file.FILE_NAME }}
                                            </div>
                                            <div class="col-6 d-flex">
                                                <div class="col-10 text-center">Upload complete</div>
                                                <font-awesome-icon :icon="faCircleXmark"
                                                    style="width: 25px; height: 30px; position: absolute; right: 3px; cursor: pointer;"
                                                    @click="removeFile(index, 'additionalFiles')" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </li>
                        </ol>
                    </div>
                    <div>
                        <label>
                            (ประเภทไฟล์ jpg / jpeg / png / pdf / ขนาดไม่เกิน
                            {{ additionalFilesInfo.LIMIT_FILE_SIZE }}
                            MB)
                        </label>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col d-flex justify-content-center">
                        <button type="button" class="btn btn-primary fs-5 px-5 text-center" data-bs-dismiss="modal"
                            @click="Submit()">
                            ส่งข้อมูล
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Hidden file input for click -->
    <input type="file" ref="fileInput-additionalFiles" @change="onFileChange($event, 'additionalFiles')"
        accept="image/*,application/pdf" multiple hidden>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

import '@/styles/SweetAlert2CustomCSS.css';

export default {
    name: "TransferPerformance",
    components: {
        Menu,
        LoadingBs5,
    },
    data() {
        return {
            faCircleXmark: faCircleXmark,
            Loading: true,
            additionalFiles: [],// เอกสารเพิ่มเติม
            isUploading: false,        // สถานะการอัปโหลด
            uploadFileLength: 10,   // จำกัดจำนวนไฟล์ในแต่ละประเภท
            RequestDocs: [],
            additionalFilesInfo: {},
            reqCodeID: 54// เปลี่ยนเป็นของงาน ส่งเอกสารเพิ่มเติม นั้นๆ
        };
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();
        this.GetRequestDoc();
    },
    methods: {
        BindingData() {
        },
        GetRequestDoc() {
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get(`AgencyERequest/GetDATA_RAW_AER_TB_REQUEST_DOCs?reqCodeID=${this.reqCodeID}`, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.additionalFilesInfo = response.data[0];

                    this.RequestDocs.push(response.data);

                    this.Loading = false;
                }
                else {
                    this.Loading = false;
                    Swal.fire({
                        icon: 'error',
                        html: `<label class="fs-4 fw-normal font-family">${response.data.ErrorMessage}</label>`,
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla btn-pill'
                        }
                    });
                    return;
                }
            }).catch((error) => {
                this.Loading = false;
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">ไม่สามารถเชื่อมต่อ API ได้ กรุณาลองใหม่อีกครั้ง</label>',
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla btn-pill'
                    }
                });
                return;
            });
        },
        Submit() {
            if (!this.checkFiles()) {
                return false;
            }
            this.Loading = true;

            const requestBody = {
                additionalDoc: this.additionalFiles,
                ReqCodeID: this.reqCodeID
            };

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.post("AgencyERequest/SendAllAdditionalDoc", requestBody, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
                if (res.status == 200 || res.status == 204) {
                    this.Loading = false;
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'บันทึกข้อมูลสำเร็จ',
                        showConfirmButton: false,
                        timer: 1500
                    }).then(() => {
                        this.$router.push({
                            name: 'FinishAdditionalDocsPage',
                            query: {
                                type: 'raceni2'
                            }
                        });
                    });
                }
                else {
                    this.Loading = false;
                    Swal.fire({
                        icon: 'error',
                        html: `<label class="fs-4 fw-normal font-family">${res.data.ErrorMessage}</label>`,
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla btn-pill'
                        }
                    });
                }
            }).catch(() => {
                this.Loading = false;
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">อัปโหลดไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง</label>',
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla btn-pill'
                    }
                });
            });

        },
        triggerFileInput(key) {
            this.$refs[`fileInput-${key}`].click(); // ใช้ `key` เพื่อเข้าถึงแต่ละ input
        },
        onFileChange(event, key) {
            const selectedFiles = Array.from(event.target.files);

            if (selectedFiles.length === 0) return; // ป้องกันการทำงานเมื่อไม่มีไฟล์ถูกเลือก

            this.handleFiles(selectedFiles, key);

            event.target.value = "";
        },
        handleFiles(files, key) {
            let totalSize = 0;
            const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
            const allowedExt = ['jpg', 'jpeg', 'png', 'pdf'];

            if (files.length + this[key].length > this[key + "Info"].LIMIT_AMOUNT_FILE) {
                Swal.fire({
                    icon: 'error',
                    html: `<lable class="fs-4 fw-normal font-family">ไม่สามารถอัปโหลดไฟล์ได้มากกว่า ${this[key + "Info"].LIMIT_AMOUNT_FILE} ไฟล์</lable>`,
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla btn-pill'
                    }
                });
                return;
            }

            files.forEach((file) => {
                // check MIME type
                const isValidType = allowedTypes.includes(file.type);

                // check นามสกุล
                const ext = file.name.split('.').pop().toLowerCase();
                const isValidExt = allowedExt.includes(ext);

                if (!isValidType || !isValidExt) {
                    Swal.fire({
                        icon: 'error',
                        html: `<lable class="fs-4 fw-normal font-family">รองรับเฉพาะไฟล์ jpg, jpeg, png, pdf เท่านั้น</lable>`,
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla btn-pill'
                        }
                    });
                    return;
                }

                if (file.size > this[key + "Info"].LIMIT_FILE_SIZE * 1024 * 1024) { // ตรวจสอบขนาดไฟล์ไม่เกิน 4MB
                    Swal.fire({
                        icon: 'error',
                        html: `<lable class="fs-4 fw-normal font-family">ไฟล์ขนาดใหญ่เกินไป กรุณาเลือกไฟล์ที่มีขนาดไม่เกิน ${this[key + "Info"].LIMIT_FILE_SIZE} MB</lable>`,
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla btn-pill'
                        }
                    });
                    return;
                }

                totalSize += file.size;

                if (totalSize > this[key + "Info"].LIMIT_FILE_SIZE * 1024 * 1024) { // ตรวจสอบขนาดรวมของไฟล์ในประเภทไม่เกิน xxx MB
                    Swal.fire({
                        icon: 'error',
                        html: `<lable class="fs-4 fw-normal font-family">ขนาดรวมของไฟล์ในประเภทนี้ไม่สามารถเกิน ${this[key + "Info"].LIMIT_FILE_SIZE} MB</lable>`,
                        customClass: {
                            popup: 'swal-wide',
                            confirmButton: 'btn-bla btn-pill'
                        }
                    });
                    return;
                }

                const reader = new FileReader();
                reader.onload = (e) => {
                    let base64String = e.target.result;
                    // ตรวจสอบ MIME type และตัดส่วนของ data URI ออก
                    if (file.type.startsWith('image/')) {
                        base64String = base64String.replace(/^data:image\/(png|jpeg|gif);base64,/, "");
                    } else if (file.type === 'application/pdf') {
                        base64String = base64String.replace(/^data:application\/pdf;base64,/, "");
                    }

                    const fileData = {
                        FILE_NAME: file.name,
                        FILE_TYPE: file.type,
                        FILE_SIZE: file.size,
                        FILE: base64String,
                        preview: file.type.startsWith('image/') ? e.target.result : '', // สำหรับไฟล์รูปภาพ
                    };

                    this.additionalFiles.push(fileData);
                };
                reader.readAsDataURL(file);

            });
        },
        removeFile(index, key) {
            this[key].splice(index, 1);

            this.$refs[`fileInput-${key}`].value = "";
        },
        formatFileSize(size) {
            const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            let i = 0;
            while (size >= 1024 && i < units.length - 1) {
                size /= 1024;
                i++;
            }
            return `${Math.round(size)} ${units[i]}`;
        },
        checkFiles() {
            if (this.additionalFiles.length === 0) {
                Swal.fire({
                    icon: 'error',
                    html: `<lable class="fs-4 fw-normal font-family">กรุณาอัปโหลดไฟล์</lable>`,
                    customClass: {
                        popup: 'swal-wide',
                        confirmButton: 'btn-bla btn-pill'
                    }
                });
                return false;
            }
            return true;
        },
        convertToBase64(file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                let base64String = e.target.result;  // ได้ Base64 ทั้งหมดรวมถึง data URI

                // ตัด "data:image/jpeg;base64," หรือ "data:image/png;base64," ออก
                base64String = base64String.replace(/^data:image\/(png|jpeg);base64,/, "");

                this.base64Data = base64String;  // เก็บค่า Base64 ที่ได้
            };

            reader.onerror = (error) => {
                console.error('Error reading file:', error);
            };

            reader.readAsDataURL(file);  // อ่านไฟล์เป็น Base64
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
    },
};

</script>